const mobileSkills = [
  {
    icon: "/icons/web-dev.svg",
    title: "Web Development",
    value: "90%",
  },
  { icon: "/icons/ui-ux.svg", title: "UI-UX", value: "85%" },
  {
    icon: "/icons/data-str.svg",
    title: "Data Structures",
    value: "95%",
  },
  {
    icon: "/icons/python.svg",
    title: "PYTHON",
    value: "95%",
  },
  {
    icon: "/icons/nextjs.svg",
    title: "Next.js",
    value: "85%",
  },
  {
    icon: "/icons/node.svg",
    title: "Node & Express",
    value: "90%",
  },
  {
    icon: "/icons/react.svg",
    title: "React",
    value: "95%",
  },
  {
    icon: "/icons/ts.svg",
    title: "TypeScript",
    value: "95%",
  },
  {
    icon: "/icons/git.svg",
    title: "Git & GitHub",
    value: "85%",
  },
  {
    icon: "/icons/flask.svg",
    title: "Flask",
    value: "90%",
  },
  {
    icon: "/icons/mongo.svg",
    title: "MongoDB",
    value: "85%",
  },
  {
    icon: "/icons/sql.svg",
    title: "SQL & RDBMS",
    value: "85%",
  },
];

export default mobileSkills;
